import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createTaskDateHeaderStyles = ({ spacing, palette }: Theme) => {
  return {
    headingWrapper: css({
      position: "relative",
      display: "flex",
      justifyContent: "center",
      margin: spacing([2, 0]),
      "&:before": {
        content: "''",
        width: "100%",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        height: 1,
        backgroundColor: grey[200],
      },
    }),
    heading: css({
      position: "relative",
      display: "inline-block",
      backgroundColor: palette.default.background,
      padding: spacing([0, 1]),
      color: grey[500],
    }),
  };
};
